import { NavLink, Outlet, useLocation, Navigate } from "react-router-dom";

const TABS = [
    { to: "users", label: "Users", key: "users" },
    { to: "groups", label: "Groups & Access", key: "groups" },
    { to: "modules", label: "Modules", key: "modules" },
    { to: "quizzes", label: "Quizzes", key: "quizzes" },
    { to: "progress", label: "Progress", key: "progress" },
    { to: "certifications", label: "Certifications", key: "certifications" },
    { to: "resources", label: "Resources", key: "resources" },
];

export default function AdminLayout() {
    const location = useLocation();
    if (location.pathname === "/admin" || location.pathname === "/admin/") {
        return <Navigate to="/admin/users" replace />;
    }
    return (
        <div className="space-y-8" data-testid="admin-layout">
            <div>
                <div className="text-[10px] uppercase tracking-[0.25em] text-ink-400 font-mono mb-3">Operations</div>
                <h1 className="font-editorial text-4xl md:text-5xl text-ink-900 leading-[1.05]">Admin.</h1>
                <p className="mt-3 text-base text-ink-500">Curate content, manage trainees, and review performance.</p>
            </div>

            <div className="border-b border-ink-300 overflow-x-auto scrollbar-thin -mx-4 px-4 sm:mx-0 sm:px-0">
                <div className="flex gap-6 min-w-max">
                    {TABS.map((t) => (
                        <NavLink
                            key={t.key}
                            to={t.to}
                            data-testid={`admin-tab-${t.key}`}
                            className={({ isActive }) =>
                                `relative pb-3 text-sm transition-colors ${isActive ? "text-ink-900" : "text-ink-500 hover:text-ink-900"}`
                            }
                        >
                            {({ isActive }) => (
                                <>
                                    {t.label}
                                    {isActive && <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-haevn-700" />}
                                </>
                            )}
                        </NavLink>
                    ))}
                </div>
            </div>

            <Outlet />
        </div>
    );
}
